export default __webpack_public_path__ + "static/media/team.b9010a32.webp";